<template>
  <div id="app">
    <localization></localization>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Localization from "@/localization";

export default {
  name: "app",
  components: { Localization },
  computed: {
    ...mapState(["settings"]),
    nextRoute() {
      return this.$route.query.redirect || "/";
    },
  },
  mounted() {
    this.$store.commit("SET_PRIMARY_COLOR", {
      color: this.settings.primaryColor,
    });
    this.$store.commit("SET_THEME", { theme: this.settings.theme });
  },
  methods: {},
  watch: {
    "$store.state.settings.theme"(theme) {
      this.$store.commit("SET_THEME", { theme });
    },
    $route(to, from) {
      const query = Object.assign({}, to.query);
      this.$store.commit("SETUP_URL_SETTINGS", query);
    },
  },
};
</script>
<style>
@media print {
  @page {
    size: auto !important;
  }
}

.ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.45) !important;
}
.container {
  margin-top: 20px;
}

.ql-editor {
  min-height: 50px !important;
  font-size: inherit !important;
}

.ict24h-editor .ql-toolbar {
  padding: 0 !important;
}

.ant-table-footer {
  padding: 8px 8px !important;
  background: #fff !important;
}

.top-table .ant-table .ant-table-placeholder {
  z-index: -1 !important;
}

.top-table .ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0 !important;
}

[v-cloak] {
  display: none;
}

.top-table .ant-table .ant-table-body {
  max-width: 100%;
  overflow-x: auto;
}

.top-d-none {
  display: none;
}

.ant-descriptions .ant-descriptions-item-label {
  font-weight: 600;
}

.top-table .ant-table {
  background: #fff !important;
}

/* CUSTOME ANT TABLE CSS 20/01/2022 */
.ant-table .ant-table-thead {
  background: #fafafa !important;
}

.ant-table .ant-table-thead th,
.ant-table .ant-table-thead td {
  font-weight: 550;
}

.ant-table.ant-table-small .ant-table-content .ant-table-body {
  margin: 0 !important;
}
/* doi mau text trong list 09/01/2024  */
.text-black-description-custom-list {
  color: #323232;
}
</style>
